import { render, staticRenderFns } from "./notificationDetail.vue?vue&type=template&id=13e499b6"
import script from "./notificationDetail.vue?vue&type=script&lang=js"
export * from "./notificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports